export default __webpack_public_path__ + "static/media/ventilacion.c35adeee.jpg";